/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { ApiTrialDto, ApiTrialRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class OrganisationTrialsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags organisation-trials-controller
   * @name GetTrials
   * @request GET:/api/v1/trials
   */
  getTrials = (params: RequestParams = {}) =>
    this.http.request<ApiTrialDto[], any>({
      path: `/v1/trials`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTrialsPath = '/v1/trials'
  static getTrialsMethod = 'GET'
  /**
   * No description
   *
   * @tags organisation-trials-controller
   * @name RequestTrial
   * @request POST:/api/v1/trials
   */
  requestTrial = (data: ApiTrialRequestDto, params: RequestParams = {}) =>
    this.http.request<ApiTrialDto, any>({
      path: `/v1/trials`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static requestTrialPath = '/v1/trials'
  static requestTrialMethod = 'POST'
}
